import { createSvgComponent } from "../../icon/createSvgComponent";
import People2 from "@core/icon/assets/people-2.svg";
export default createSvgComponent(People2);